// A confirmed USD cap blocks a run only when a real dollar estimate is
// known and strictly above the cap. Equality is allowed. A missing
// estimate does not invent one.

export function estimateExceedsCap(
  estimateUsd: number | null,
  capUsd: number | null | undefined
): boolean {
  if (capUsd == null || estimateUsd == null) return false;
  if (!Number.isFinite(estimateUsd) || !Number.isFinite(capUsd)) return false;
  return estimateUsd > capUsd;
}
